import {
  ADMIN_PANEL_SECTION_CONFIG_FE_KEYS,
  ADMIN_PANEL_SECTION_CONFIG_FE_STATUS,
} from "features/AdminPanel/constants/AdminPanel.constants";
import { is_empty } from "features/Common/utils/common.utils";

const hasStatus = (inputStatus) => (configValue) => {
  const {
    [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.FE_METADATA]: {
      [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.UPDATION_STATUS]: {
        [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.STATUS]: status,
      } = {},
    } = {},
  } = configValue;

  return status === inputStatus;
};

export const getUpdationStatus = (sectionConfig) => {
  if (is_empty(sectionConfig)) return null;

  const values = Object.values(sectionConfig);

  const isSaving = values.some(
    hasStatus(ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.SAVING)
  );
  if (isSaving) return ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.SAVING;

  const isError = values.some(
    hasStatus(ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.ERROR)
  );
  if (isError) return ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.ERROR;

  const isSaved = values.some(
    hasStatus(ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.SAVED)
  );
  if (isSaved) return ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.SAVED;

  return null;
};
